import enumeration from "./enumeration";

const TapStatus = {
  Success: "SUCCESS",
  Failed: "FAILED",
};

export default enumeration(TapStatus);
